import { ApiKeychainSchema } from "../../../utils/types";
import { CornerDownRight, Eye } from 'react-feather';
import { InternalLink } from "../../../components/internal-link/InternalLink";
import { formatDate } from "../../../utils/time";
import { ContentButton } from "../../../components/button/ContentButton";

import "./ApiKeychainCard.scss";

interface ApiKeychainCardProps {
  apiKeychain: ApiKeychainSchema;
  mode?: 'card' | 'page';
}

export default function ApiKeychainCard({ apiKeychain, mode = 'card' }: ApiKeychainCardProps) {
  const usageType = apiKeychain.usage_type || 'standalone';
  const usageTypeLabel = usageType;
  const agentConfig = apiKeychain.agent?.agentConfigs[0];
  const pkg = apiKeychain.package;

  return (
    <div data-component="ApiKeychainCard" data-mode={mode}>
      <div className="api-keychain-name">
        <InternalLink to={`/dashboard/api-keychains/${apiKeychain.unique_id}`}>
          {apiKeychain.alias || '(No alias)'}
        </InternalLink>
      </div>
      <div className="api-keychain-header">
        <span>Usage type</span>
        <strong>
          {usageTypeLabel}
        </strong>
        <div className="spacer" />
        <span>
          {formatDate(new Date(apiKeychain.created_at))}
        </span>
      </div>
      {apiKeychain.agent && (
        <div className="api-keychain-attachment">
          <CornerDownRight />
          <div className="api-keychain-attachment-body">
            <div className="api-keychain-attachment-icon agent">
              <img src={agentConfig?.profile_image_url || '/logo/instant-bot-avatar.svg'} alt={agentConfig?.name} />
            </div>
            <div className="api-keychain-attachment-name">
              <InternalLink to={`/chat/${apiKeychain.agent.unique_id}`}>{agentConfig?.name}</InternalLink>
            </div>
          </div>
        </div>
      )}
      {apiKeychain.package && (
        <div className="api-keychain-attachment">
          <CornerDownRight />
          <div className="api-keychain-attachment-body">
            {pkg?.thumbnail_image_url && (
              <div className="api-keychain-attachment-icon package">
                <img src={pkg?.thumbnail_image_url || ''} alt={pkg?.display_name} />
              </div>
            )}
            <div className="api-keychain-attachment-name">
              <InternalLink to={`/packages/${pkg?.display_name}`}>{pkg?.display_name}</InternalLink>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
